import { render, staticRenderFns } from "./ProjectLastFeatures.vue?vue&type=template&id=4a04c0a4&scoped=true"
import script from "./ProjectLastFeatures.vue?vue&type=script&lang=js"
export * from "./ProjectLastFeatures.vue?vue&type=script&lang=js"
import style0 from "./ProjectLastFeatures.vue?vue&type=style&index=0&id=4a04c0a4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a04c0a4",
  null
  
)

export default component.exports